/* eslint "react/no-unescaped-entities": "off" */
export const whyKeenData = [
  {
    title: "You Don't Need Psychics Near You",
    text: (
      <div data-testid="text">
        First of all, exactly how many psychics are actually in your demographic
        area and how do you know what type of reputation they have? With that in
        mind, why not try a psychic reading online? With Keen, you can review
        ratings and reviews from thousands of credible psychics who are
        available 24/7/365, over the phone, through online chat or email at{' '}
        <a href="https://www.keen.com/">www.keen.com</a>, 1-800-ASK-KEEN
        (800-275-5336) or through our{' '}
        <a href="https://help.keen.com/hc/en-us/articles/360053006194-Why-You-Should-Download-the-Keen-Psychic-Reading-App">
          App
        </a>
        . Aside from convenience and selection, there's also the anonymity
        factor. Oftentimes, people seek psychic advice for a difficult situation
        of which they may feel embarrassed to look someone in the eye and bare
        their soul.
      </div>
    )
  },
  {
    title: 'How to Have a Great Psychic Reading',
    text: (
      <div data-testid="text">
        When you're on the phone or your computer with an online psychic, you
        are more inclined to open yourself up - an absolute must for any{' '}
        <span style={{ textDecoration: 'underline' }}>successful reading</span>.
        Not to mention, when you're not meeting someone in person, they are less
        apt to pick up on your body language, what you're wearing, etc., to make
        an assessment that has nothing to do with psychic power. If you're
        worried about which one offers a better result, you can relax. You need
        not have your hands on the cards to receive a proper reading. A talented
        and experienced advisor can work with you no matter where in the world
        you're residing.
      </div>
    )
  },
  {
    title: 'How to Find the Perfect Psychic Near You',
    text: (
      <div
        data-testid="text"
        id="question3"
        className="collapse answer-container">
        Like any relationship, you want to find a psychic who is trustworthy and
        has your best interests in mind while being a person you feel
        comfortable opening up to. Even though you're not face-to-face, it's
        definitely important that you two have some semblance of synergy. Do
        your due diligence by reading the <a href="/all-categories">profiles</a>{' '}
        in the applicable category you are seeking. While a bio can inform you
        about the experience, it can also give you an idea of what a psychic's
        personality is like, based on the way it's written. It's also a good
        idea to read the reviews of others to get a sense of what a session will
        be like with this person. Remember, there's no need to commit to a long
        reading the first time. Think of it as an interview to see if you two
        are on the same page and if you liked the psychic's approach to your
        situation. If you're new to Keen, take advantage of an introductory 3
        free minutes to try the service.
      </div>
    )
  },
  {
    title: 'Gain Clarity on Love, Relationships, Career, Family, and More',
    text: (
      <div data-testid="text">
        No matter what scenario you're going through in your life, Keen's
        advisors offer a multitude of{' '}
        <a href="/all-categories">psychic readings</a> to help you out. If
        you're feeling a bit lost and feel the need to conduct a little
        self-exploration, give an astrology reading a try. A love advisor can
        help you find clarity at any stage in your life, whether that's a
        breakup or divorce, preparing for marriage, or looking for love. Not
        sure what type of reading to book? A tarot reading can help an
        individual with pretty much anything, whether that means personal
        growth, soul searching, goal setting, self-care, making a career change,
        relationship issues, and more. Ask a psychic to help you choose the best
        reading based on your needs.
      </div>
    )
  }
];

export default whyKeenData;
